import styled, { css } from "styled-components";
import { ReactSVG } from "react-svg";

export const CheckboxContainer = styled.div`
  width: 5rem;
  height: 35px;
  padding-left: 5px;
  margin: 0px 4px;
  border-radius: 5px;
  /* display: flex;
  align-items: center; */
`;

export const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  overflow: hidden;
  white-space: nowrap;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
`;
